
import { Component, Vue } from 'vue-property-decorator'
import { notification } from 'ant-design-vue'
import axios from 'axios'
import UserSetting from '@/types/userSetting'
import ls from '@/ls'

const O365_REDIRECT_STORAGE_KEY = 'o365LoginRedirect'

@Component({
  components: {}
})

export default class Login extends Vue {
  username = ''
  password = ''
  loading = false

  mounted () : void {
    if (this.$store.getters['authStore/isLoggedIn']) {
      this.redirect()
    }
  }

  login () : void {
    const username = this.username
    const password = this.password
    this.loading = true

    this.$store.dispatch('authStore/login', { username, password }).then(() => {
      this.getUserSettings()
      this.redirect()
    }).catch((e) => {
      if (e.response.status === 401) {
        notification.error({ message: 'Onjuiste gebruikersnaam en/of wachtwoord!', description: 'De door jou ingevulde combinatie van gebruikersnaam en wachtwoord is niet bij ons bekend. Probeer het nog een keer.' })
      } else if (e.response.status === 403 && e.response.data === 'Account inactive.') {
        notification.error({ message: 'Account inactief!', description: 'De door jou ingevulde combinatie van gebruikersnaam en wachtwoord is niet meer actief.' })
      } else {
        notification.error({ message: 'Fout tijdens inloggen!', description: 'Er is iets mis gegaan. Probeer het later nog een keer.' })
      }
    }).finally(() => {
      this.loading = false
    })
  }

  loginWithO365 () : void {
    const appDomain = process.env.NODE_ENV === 'development'
      ? process.env.VUE_APP_MS_CALLBACK_DOMAIN + (process.env.VUE_APP_USE_PRETTY_URL === 'yes' ? '' : ':' + process.env.VUE_APP_PORT)
      : process.env.VUE_APP_MS_CALLBACK_DOMAIN

    const redirectPath = this.getSafeRedirectPath()
    if (redirectPath) {
      ls.set(O365_REDIRECT_STORAGE_KEY, redirectPath)
    } else {
      ls.remove(O365_REDIRECT_STORAGE_KEY)
    }

    window.location.href = process.env.VUE_APP_API_URL + '/loginWithO365?appDomain=' + appDomain
  }

  getUserSettings () : void {
    axios.get(process.env.VUE_APP_API_URL + '/users/admin/settings').then((res) => {
      if (res.data.length) {
        res.data.forEach((setting:UserSetting) => {
          ls.set(setting.setting_name, setting.setting_value)
        })
      }
    })
  }

  redirect () : void {
    const redirectPath = this.getSafeRedirectPath()
    if (redirectPath) {
      this.$router.push(redirectPath)
      return
    }

    this.$router.push({ name: 'dashboard' })
  }

  getSafeRedirectPath () : string | null {
    const redirect = this.$route.query.redirect
    if (typeof redirect !== 'string') {
      return null
    }

    if (!redirect.startsWith('/') || redirect.startsWith('//') || redirect.includes('://')) {
      return null
    }

    return redirect
  }

  get blockNormalLogin () : boolean {
    return this.username.includes('@thunnissen.nl')
  }

  get appVersion () : string {
    return process.env.VUE_APP_VERSION
  }
}
